<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const year = computed(() => new Date().getFullYear())

const isFooterBarVisible = computed(() => !store.state.isFullScreen)
</script>

<template>
  <footer
    v-show="isFooterBarVisible"
    class="border-t border-gray-200 dark:border-gray-700"
  >
    <div class="w-full mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-8 py-4
                flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <p class="text-sm text-gray-500 dark:text-gray-400 text-center sm:text-left">
        <span class="font-semibold text-gray-700 dark:text-gray-300">Toplistbot.com</span>
        <span class="mx-1.5 text-gray-300 dark:text-gray-600">&middot;</span>
        <span>&copy; {{ year }}</span>
      </p>
      <nav class="flex items-center justify-center gap-4 text-sm">
        <a
          href="https://toplistbot.com/docs"
          target="_blank"
          rel="noopener noreferrer"
          class="text-gray-500 hover:text-brand-600 dark:text-gray-400 dark:hover:text-brand-400 transition-colors
                 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          Documentation
        </a>
        <a
          href="https://toplistbot.com"
          target="_blank"
          rel="noopener noreferrer"
          class="text-gray-500 hover:text-brand-600 dark:text-gray-400 dark:hover:text-brand-400 transition-colors
                 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          Website
        </a>
      </nav>
    </div>
  </footer>
</template>
